<template>
    <div>
        <van-popup v-model="show" :overlay-style="overlayStyle" @click-overlay="close">
            <div class="tips_pop">
                <div class="tips_top">
                    <!-- <div class="tips_close" @click="close">
                        <i class="iconfont icon-s-cuowu-guanbi"></i>
                    </div> -->
                </div>
                <div class="tips_box">
                    <div class="tips_title">
                        <img :src="$themeImage('share.redemptionCodeTitle')" />
                    </div>
                    <div class="tips">{{ $t("RedemptionCode.tips1") }}</div>
                    <a-input v-model="code" :placeholder="$t('RedemptionCode.PleaseEnterTheRedemptionCode')"></a-input>
                    <div class="platforms_icons">
                        <img v-for="(item, index) in platforms.slice(0, 3)" :key="index" :src="item.icon" @click="onNavTo({ url: item.url, type: 'href' })" />
                    </div>
                </div>
                <div class="tips_footer" @click="confirm">
                    {{ $t("RedemptionCode.exchange") }}
                </div>
            </div>
            <div class="close_btn" @click="close">
                <i class="iconfont icon-s-cuowu-guanbi"></i>
            </div>
        </van-popup>
        <upBonusPopup ref="upBonusPopup" @getNormalReward="onReceiveReward"></upBonusPopup>
    </div>
</template>

<script>
import { getDrawDown, getRedEnvelopeDetail } from '@/api/bonusCenter'
import upBonusPopup from '@/views/weeklySalary/modules/upBonusPopup.vue'
import { Toast } from 'vant'
export default {
    props: {
        tips: {
            type: String,
            default: ''
        },
        tips2: {
            type: String,
            default: ''
        }
    },
    components: { upBonusPopup },
    computed: {
        sysConfig() {
            return this.$store.getters.sysConfig
        },
        themeSkin() {
            return this.$store.getters.themeSkin
        },
        overlayStyle() {
            return {
                background: 'var(--theme-popup-overlay-bg)'
            }
        }
    },
    watch: {
        sysConfig: {
            handler: function (newVal, oldVal) {
                if (newVal) {
                    this.GetPlatforms()
                }
            },
            deep: true,
            immediate: true
        },
        themeSkin() {
            this.GetPlatforms()
        }
    },
    data() {
        return {
            show: false,
            code: '',
            platforms: [],
            isCanReceiveReward: true,
            upBonusData: null
            // bonusCanLevelUp: '',
            // dailyLimitTimeState: '',
            // dailyLimitTimeJson: ''
        }
    },
    methods: {
        close() {
            this.show = false
            this.$emit('close')
        },
        open(D) {
            this.show = true
            const code = this.$store.state.user.redEnvelopeCode
            if (code) {
                this.code = code
                this.upBonusData = D
                this.upBonusData.code = code
            }
            this.GetPlatforms()
        },
        confirm() {
            const that = this
            if (!that.code) {
                Toast(that.$t('RedemptionCode.PleaseEnterTheRedemptionCode2'))
                return
            }
            const params = {
                code: that.code.trim()
            }
            if (that.upBonusData && that.upBonusData.code === params.code && that.upBonusData.bonusCanLevelUp === 'Yes') {
                const D1 = that.upBonusData
                const item = {
                    type: 'redEnvelope',
                    amount: D1.singleAmt,
                    levelUpAmount: D1.bonusLevelUpBonusAmt,
                    rewardRecordId: D1.redEnvelopeId,
                    rewardState: 'canClaim',
                    upgradeBonusLevelUpRechargeAmt: D1.bonusLevelUpRechargeAmt,
                    depositType: 'redEnvelope'
                }
                that.$refs.upBonusPopup.open(item)
            } else if (that.upBonusData && that.upBonusData.code === params.code && that.upBonusData.bonusCanLevelUp !== 'Yes') {
                that.onReceiveReward()
                that.$emit('confirm')
            } else {
                getRedEnvelopeDetail(params).then((res1) => {
                    if (res1.code) return
                    const D1 = res1.result
                    that.upBonusData = D1
                    that.upBonusData.code = that.code.trim()
                    if (D1.bonusCanLevelUp === 'Yes') {
                        const item = {
                            type: 'redEnvelope',
                            amount: D1.singleAmt,
                            levelUpAmount: D1.bonusLevelUpBonusAmt,
                            rewardRecordId: D1.redEnvelopeId,
                            rewardState: 'canClaim',
                            upgradeBonusLevelUpRechargeAmt: D1.bonusLevelUpRechargeAmt,
                            depositType: 'redEnvelope'
                        }
                        that.$refs.upBonusPopup.open(item)
                    } else {
                        that.onReceiveReward()
                        that.$emit('confirm')
                    }
                })
            }
        },
        onReceiveReward() {
            const that = this
            if (that.isCanReceiveReward) {
                that.isCanReceiveReward = false
                const params = {
                    code: that.code.trim()
                }
                getDrawDown(params).then((res) => {
                    if (res.code) return
                    that.$store.dispatch('user/setRedEnvelopeCode', '')
                    that.close()
                    Toast(res.message)
                }).finally(() => {
                    that.isCanReceiveReward = true
                })
            }
        },
        GetPlatforms() {
            this.platforms = []
            const systemConfig = this.sysConfig
            if (!systemConfig) return
            const whatsapp = systemConfig.whatsapp?.trim()
            if (whatsapp) {
                const platform5 = {
                    id: 4,
                    icon: this.$themeImage('share.iconWhatsapp'),
                    title: 'Whatsapp',
                    url: whatsapp,
                    linkType: 'href'
                }
                this.platforms.push(platform5)
            }
            const telegramGroup = systemConfig.telegramGroup?.trim()
            if (telegramGroup) {
                const platform8 = {
                    id: 1,
                    icon: this.$themeImage('share.iconTelegram'),
                    title: 'Telegram',
                    url: telegramGroup,
                    linkType: 'href'
                }
                this.platforms.push(platform8)
            }
            const instagram = systemConfig.instagram?.trim()
            if (instagram) {
                const platform3 = {
                    id: 2,
                    icon: this.$themeImage('share.iconInstagram'),
                    title: 'Instagram',
                    url: instagram,
                    linkType: 'href'
                }
                this.platforms.push(platform3)
            }
        }
    }
}
</script>

<style scoped lang="scss">
@import '@/common/styles/viriables.scss';
.van-popup {
    background: transparent;
    width: 100%;
}

.close_btn {
    width: .8rem;
    height: .8rem;
    display: flex;
    align-items: center;
    justify-content: center;
    background: var(--theme-popup-close-bg);
    margin: .3rem auto;
    border-radius: .1rem;
    border: 1px solid var(--theme-popup-close-border);
    color: var(--theme-bright-text);
    cursor: pointer;
    .iconfont {
        font-size: .4rem;
    }
}

.tips_pop {
        position: relative;
        background-image: var(--theme-common-frame-corner-top-left),
            /* 左上角 */
            var(--theme-common-frame-corner-top-right),
            /* 右上角 */
            var(--theme-common-frame-corner-bottom-left),
            /* 左下角 */
            var(--theme-common-frame-corner-bottom-right),
            var(--theme-popup-bg);
        /* 右下角 */

        /* 四个角位置 ↓ 一一对应 */
        background-position: left top,
            right top,
            left bottom,
            right bottom,
            center center;

        /* 不重复 */
        background-repeat: no-repeat;

        /* 图片大小（根据你需求调整） */
        background-size: 2.25rem 1.5rem,
            2.25rem 1.5rem,
            2.25rem 1.5rem,
            2.25rem 1.5rem,
            100% 100%;

        &::before {
            content: '';
            position: absolute;
            left: 0;
            top: 0;
            right: 0;
            bottom: 0;
            pointer-events: none;
            background-image:
                var(--theme-frame-line-vertical),
                var(--theme-frame-line-vertical);
            background-position: left center, right center;
            background-size: 0.04rem 100%, 0.04rem 100%;
            background-repeat: no-repeat;
        }

        &::after {
            content: '';
            position: absolute;
            left: 0;
            top: 0;
            right: 0;
            bottom: 0;
            pointer-events: none;
            background-image:
                var(--theme-frame-line-horizontal),
                var(--theme-frame-line-horizontal);
            background-position: center top, center bottom;
            background-size: 100% 0.04rem, 100% 0.04rem;
            background-repeat: no-repeat;
        }
    }

.tips_pop {
    padding: .26rem .46rem;
    width: 94%;
    max-width: 8rem;
    border-radius: .2rem;
    margin: 0 auto;
    padding-bottom: .06rem;
    height: auto;

    .tips_top {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        // margin: 0 .3rem;
        position: relative;
        z-index: 0;
        height: 1rem;

        .tips_close {
            width: .42rem;
            height: .42rem;
            cursor: pointer;
            color: $font-color;
            position: absolute;
            right: -.22rem;
            top: 0;
            i{
                font-size: .38rem;
                font-weight: 400;
            }
        }
    }

    .tips_box {
        font-size: .24rem;
        padding:  0 .5rem;
        position: relative;
        z-index: 1;
        background: var(--theme-popup-panel-bg);
        box-shadow: inset 8px 8px 30px 0px rgba(255,255,255,0.2), inset -8px -8px 30px 0px rgba(255,255,255,0.2);
        border-radius: .3rem;
        border: 2px solid var(--theme-popup-box-border);

        .tips_title {
            width: 3rem;
            margin: -1rem auto 0 auto;
            & > img{
                width: 100%;
                height: auto;
            }
        }

        .tips{
            text-align: left;
            color: var(--theme-bright-text);
            font-size: .24rem;
            font-weight: bold;
            margin-bottom: .2rem;
            box-sizing: border-box;
        }

        .platforms_icons{
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            margin: .28rem 0;
            gap: .3rem;
            margin-bottom: .52rem;

            & > img{
                width: .88rem;
                height: .88rem;
            }
        }

        .tips2 {
            margin-top: .2rem;
        }

        ::v-deep input::-webkit-outer-spin-button {
            -webkit-appearance: none;
        }

        ::v-deep input::-webkit-inner-spin-button {
            -webkit-appearance: none;
        }

        ::v-deep input[type='number'] {
            -moz-appearance: textfield;
        }

        ::v-deep .ant-input {
            background: var(--theme-input-bg) !important;
            border-radius: 0.14rem;
            font-size: 0.32rem;
            height: .8rem;
            padding: 0px 0.24rem !important;
            color: var(--theme-bright-text);
            border: .02rem solid var(--theme-input-border) !important;
            padding-left: .2rem !important;

            &:focus {
                background: var(--theme-input-focus-bg);
                border-color: var(--theme-input-focus-border) !important;
            }

            &::-webkit-input-placeholder {
                /* WebKit browsers */
                font-size: .32rem;
                color: var(--theme-input-placeholder);
                opacity: .7;
                font-weight: 100;
            }

            &:-moz-placeholder {
                /* Mozilla Firefox 4 to 18 */
                font-size: .32rem;
                color: var(--theme-input-placeholder);
            }

            &::-moz-placeholder {
                /* Mozilla Firefox 19+ */
                font-size: .32rem;
                color: var(--theme-input-placeholder);
            }

            &:-ms-input-placeholder {
                /* Internet Explorer 10+ */
                font-size: .32rem;
                color: var(--theme-input-placeholder);
            }

        }
    }

    .tips_footer {
        padding: 0 .5rem;
        width: fit-content;
        box-sizing: border-box;
        height: .8rem;
        background: $bg-btn-color;
        line-height: .73rem;
        text-align: center;
        font-size: .4rem;
        color: var(--theme-gold-text);
        margin: .5rem auto;
        cursor: pointer;
        border-radius: .9rem;
        background: var(--theme-gold-bg);
        box-shadow: 0px 4px 4px 0px rgba(0,0,0,0.3);
    }
}
</style>
